module.exports = __webpack_public_path__ + "img/gsb6.fcb629be.png";